import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { t } from '../../i18n/translate.js';
import '../../i18n/i18n.js';
import '../../services/apiEndpoint/apiEndpoint.js';
import '../../services/appConstants/appConstants.js';
import '../../node_modules/tslib/tslib.es6.js';
import 'react-ga4';
import '../../services/utilities/countries.js';
import '@sentry/react';
import client from '../../services/graphql/client.js';
import 'axios';
import 'date-fns/isAfter';
import 'date-fns/addMinutes';
import '../../services/logout/rest-default-client/restDefaultClient.js';
import '../../services/poller/PollManager.js';
import 'react-dom';
import '../../services/ipcWeb/IpcContext.js';
import 'js-cookie';
import 'react-i18next';
import '../../services/translation/translationUtils.module.scss.js';
import '../../services/utilities/languageUtil.js';
import '../../services/useContactUs/ContactUs.gql.js';
import '../../services/storageHandler/StorageHandler.js';
import '../../services/abortablePromise/AbortablePromise.js';
import '../../services/abortablePoller/AbortablePoller.js';
import '../../services/abortablePoller/ResumablePoller.js';
import '../../services/ipcWeb/ipcService.js';
import Button from '../../components/Button/Button.js';
import '../../components/AppLogo/AppLogo.js';
import '../../components/Avatar/Avatar.js';
import '../../components/Input/Input.js';
import '../../components/Input/PasswordInput.js';
import '../../components/Icon/Icon.js';
import '../../components/Image/Image.js';
import 'classnames';
import '../../components/LoadingSpinner/LoadingSpinner.module.scss.js';
import '../../components/Note/Note.js';
import '../../components/RadioButton/RadioButton.js';
import '../../components/RoundButton/RoundButton.js';
import '../../components/RoundButton/RoundButtonElement/RoundButtonElement.js';
import '../../components/Expandable/Expandable.js';
import '../../components/PopOver/PopOver.js';
import '../../components/Wizard/Wizard.js';
import '../../components/Wizard/WizardStepContent/WizardStepContent.js';
import '../../components/Wizard/NavigationBar/NavigationBar.js';
import '../../components/ToggleButton/ToggleButton.js';
import '../../components/ToggleButton/ToggleButtonElement/ToggleButtonElement.js';
import '../../components/Wizard/ProgressBar/ProgressBar.js';
import '../../components/Checkbox/Checkbox.js';
import '../../components/SelectionField/SelectionField.js';
import '../../components/Card/Card.js';
import '../../components/Badge/Badge.js';
import '../../components/SettingsItem/SettingsItem.js';
import '../../components/SortableList/SortableList.js';
import '../../components/Contacts/ContactItem.js';
import '../../components/TopElement/TopElement.js';
import '../../components/SidePanelInfoBox/SidePanelInfoBox.js';
import '../../components/Flag/Flag.js';
import '../../components/DropDownBox/DropDownBox.module.scss.js';
import '../../components/PhoneSelectButton/PhoneSelectButton.module.scss.js';
import '../../components/InternationalPhonePicker/InternationalPhonePicker.module.scss.js';
import '../../components/Carousel/ImageCarousel.module.scss.js';
import ArmStateButton from './ArmStateButton.js';
import useDisarm from './useDisarm.js';
import styles from './ArmDisarmPanel.module.scss.js';

var ArmDisarmPanel = function (_a) {
    var instance = _a.instance;
    var panel = instance.panel, removeSubPanel = instance.removeSubPanel, onValidate = instance.onValidate, pinCodeLength = instance.pinCodeLength, giid = instance.giid, armStateStatus = instance.armStateStatus, remainingSms = instance.remainingSms, chargeArmDisarm = instance.chargeArmDisarm, isBroadbandConnected = instance.isBroadbandConnected, _b = instance.client, client$1 = _b === void 0 ? client : _b;
    var onClose = function () {
        dispatch(removeSubPanel(panel));
    };
    var dispatch = useDispatch();
    var _c = useState(''), pinCode = _c[0], setPinCode = _c[1];
    var _d = useState(''), error = _d[0], setError = _d[1];
    var _e = useDisarm(setError, onValidate, onClose), startDisarm = _e.startDisarm, isPolling = _e.isPolling;
    var canStartDisarm = pinCode.length === pinCodeLength;
    var hasSmsOrEth = remainingSms > 0 || isBroadbandConnected || !chargeArmDisarm;
    return (React.createElement("div", { className: styles.contentWrapper, id: "arm-disarm-panel" },
        React.createElement("div", { className: styles.fullWidth },
            React.createElement("h1", { className: styles.title, id: "disarmTitle" }, t('MPLIB_DISARM_TITLE')),
            React.createElement("p", { className: styles.text }, t('MPLIB_DISARM_DESCR')),
            React.createElement(ArmStateButton, { setPinCode: setPinCode, pinCode: pinCode, isPolling: isPolling, armStateStatus: armStateStatus, pinCodeLength: pinCodeLength, hasSmsOrEth: hasSmsOrEth }),
            React.createElement("p", { className: styles.error, id: "disarmError" }, error)),
        React.createElement("div", { className: styles.buttonBar },
            React.createElement(Button, { dataTestId: "cancel", text: t('MPLIB_CANCEL'), onClick: onClose, className: styles.optionButton, flat: true, cancel: true }),
            React.createElement(Button, { dataTestId: "doit", disabled: !canStartDisarm || isPolling, text: t('MPLIB_DISARM_BUTTON'), onClick: function () { return startDisarm(giid, pinCode, client$1); }, className: styles.optionButton, flat: true }))));
};
ArmDisarmPanel.propTypes = {
    instance: PropTypes.shape({
        panel: PropTypes.string.isRequired,
        onValidate: PropTypes.func.isRequired,
        removeSubPanel: PropTypes.func.isRequired,
        pinCodeLength: PropTypes.number.isRequired,
        giid: PropTypes.string.isRequired,
        remainingSms: PropTypes.number.isRequired,
        chargeArmDisarm: PropTypes.bool.isRequired,
        isBroadbandConnected: PropTypes.bool.isRequired,
    }).isRequired,
};
ArmDisarmPanel.defaultProps = {};

export { ArmDisarmPanel as default };
